import { Icon } from '@iconify/react';
import RevealWrap from './RevealWrap';

const INCLUDES = [
  'QR 오더 시스템 전체',
  '다국어 메뉴 자동 지원',
  'POS 완벽 연동',
  '네이버 카카오 리뷰 연동',
  '전담 매니저 배정',
  '365일 24시간 고객지원',
  '설치비 완전 무료',
  '추가 과금 일절 없음',
];

export default function Pricing() {
  return (
    <section id="pricing" className="py-28 lg:py-40 bg-white relative overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-brand-100/30 rounded-full blur-3xl pointer-events-none -translate-y-1/2" />

      <div className="max-w-4xl mx-auto px-6 lg:px-8 relative z-10">
        <RevealWrap animation="scale" className="text-center mb-20">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-brand-50 border border-brand-200 mb-8">
            <Icon icon="solar:tag-bold" className="text-brand-600 text-sm" />
            <span className="text-brand-700 text-sm font-semibold">첫 1개월 완전 무료</span>
          </div>
          <h2 className="text-3xl lg:text-5xl font-bold leading-snug lg:leading-snug tracking-tight text-neutral-900 mb-6">
            솔직히, 이 가격이<br />맞나 싶으실 겁니다
          </h2>
          <p className="text-neutral-500 text-lg leading-relaxed max-w-md mx-auto">
            치킨 1~2마리 가격으로 매장이 완전히 달라집니다.<br className="hidden sm:block" />
            직접 상담받아 보시면 압니다.
          </p>
        </RevealWrap>

        <RevealWrap animation="scale" className="reveal-delay-1">
          <div className="max-w-2xl mx-auto">
            <div className="grid sm:grid-cols-2 gap-4 mb-8">
              <div className="bg-red-50 border border-red-200/60 rounded-2xl p-6 text-center">
                <p className="text-neutral-500 text-sm mb-2">QR오더 없이 매달 놓치는 매출</p>
                <p className="text-red-500 text-3xl font-bold">수백만 원</p>
                <p className="text-red-400 text-xs mt-1">리뷰 유입 감소 + 회전율 저하</p>
              </div>
              <div className="bg-brand-50 border border-brand-200 rounded-2xl p-6 text-center">
                <p className="text-neutral-500 text-sm mb-2">와우오더 월 이용료</p>
                <p className="text-neutral-900 text-3xl font-bold">치킨 1~2마리</p>
                <p className="text-brand-600 text-xs mt-1 font-semibold">이게 전부입니다. 진짜로.</p>
              </div>
            </div>

            <div className="bg-neutral-50 border border-neutral-200/80 rounded-2xl p-8 mb-8">
              <p className="text-sm font-bold text-neutral-900 mb-5">이 가격에 전부 포함됩니다</p>
              <div className="grid sm:grid-cols-2 gap-x-6 gap-y-3.5">
                {INCLUDES.map((item) => (
                  <div key={item} className="flex items-center gap-3">
                    <Icon icon="solar:check-circle-bold" className="text-brand-500 text-lg flex-shrink-0" />
                    <span className="text-neutral-700 text-sm">{item}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="text-center mb-8">
              <p className="text-neutral-900 font-bold text-lg mb-1">
                숨겨진 비용? 추가 과금? 일절 없습니다.
              </p>
              <p className="text-neutral-400 text-sm">
                약정 기간 중 추가되는 비용은 단 1원도 없습니다
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="tel:1644-6827"
                className="flex-1 group flex items-center justify-center gap-2 bg-brand-400 text-neutral-900 font-semibold py-4 rounded-xl hover:bg-brand-500 transition-all duration-300 text-base"
              >
                <Icon icon="solar:phone-bold" className="text-lg" />
                정확한 가격 확인하기
              </a>
              <a
                href="http://pf.kakao.com/_fgiMX/chat"
                target="_blank"
                rel="noopener noreferrer"
                className="flex-1 flex items-center justify-center gap-2 bg-neutral-900 text-white font-semibold py-4 rounded-xl hover:bg-neutral-800 transition-all duration-300 text-base"
              >
                <Icon icon="solar:chat-round-dots-bold" className="text-lg" />
                카카오톡으로 문의
              </a>
            </div>

            <p className="text-neutral-400 text-xs text-center mt-5">
              전화 한 통이면 매장에 맞는 정확한 견적을 바로 안내받으실 수 있습니다
            </p>
          </div>
        </RevealWrap>
      </div>
    </section>
  );
}
